<template>
  <main class="main lh-15">
    <div class="banner blog-banner p-r">
      <div class="banner-text-wrap">
        <strong class="m-0 fw-700 ta-c c-fff main-title">Blog <i></i></strong>
      </div>
    </div>
    <div class="content">
      <div class="tabs nav-anchor d-f jc-c c-666 ta-c">
        <h2
          v-for="(item, index) in tabsNav"
          @click="clickTab(item.val, index)"
          :key="index"
          :class="avtiveIndex === index ? 'curr' : ''"
          class=""
        >
          <span>{{ item.title }}</span>
        </h2>
      </div>
      <blogPageCard :blog-data="blogListData" />
      <div class="more-btn ta-c fs-16 m-a" v-show="hsaMore" @click="loadMore">
        <a href="javascript:;">Load More</a>
      </div>
    </div>
  </main>
</template>

<script>
  import { mapGetters } from 'vuex'
  import blogPageCard from '@/components/BlogCard/blogPageCard.vue'
  // import blogPageCard from '@/components/BlogCard'
  import bannerScroll from '@/mixins/bannerScroll.js'
  import { langMap } from '@/config/language'

  const blogTypeMap = {
    CompanyNews: 1,
    ProductUpdates: 3,
    UserCase: 4,
    Technology: 5
  }

  export default {
    components: {
      blogPageCard
    },
    mixins: [bannerScroll],
    async asyncData({ route, i18n, $api }) {
      const routeName = route.query.name
      const blogCategory = routeName ? blogTypeMap[routeName] : 1
      console.log('[ routeName,blogCategory ] >', routeName, blogCategory)
      const languageCode = langMap[i18n.loadedLanguages[0]] || 'en-US'
      const { data, totalCount } = await $api.blogApi.getBlogList({
        languageCode,
        blogCategory,
        pageNum: 1,
        pageSize: 6
      })
      console.log('[ data ] >', data)
      // console.log('[ recentPostsData ] >', recentPostsData)
      return {
        // swiperData: data
        blogListData: data || [],
        totalCount: totalCount || 0
      }
    },
    data() {
      return {
        avtiveIndex: 0,
        pageNum: 1,
        pageSize: 6,
        hsaMore: false,
        // totalCount:0,
        tabsNav: [
          { title: 'Company News', val: 1 },
          { title: 'Product Updates', val: 3 },
          { title: 'User Case', val: 4 },
          { title: 'Technology', val: 5 }
        ],
        blogListData: [],
        blogCategory: 1
      }
    },
    computed: {
      routerParams() {
        console.log('[ this.$route.params && this.$route.params.id ] >', this.$route.query.name)
        return (this.$route.query && this.$route.query.name) || ''
      },
      ...mapGetters({
        language: 'routerLang'
      })
    },

    watch: {
      '$route.query.name': {
        handler(newVal, oldVal) {
          if (newVal !== oldVal) {
            const routeMap = {
              CompanyNews: 0,
              ProductUpdates: 1,
              UserCase: 2,
              Technology: 3
            }

            this.avtiveIndex = routeMap[this.routerParams] || 0
          }
        },
        immediate: true
      }
    },
    // watchQuery: true,
    watchQuery: ['id'],
    created() {
      // console.log('[ this.$route ] >', this.$route.params
    },
    mounted() {},
    methods: {
      clickTab(type, index) {
        console.log('[ this.$i18n ] >', this.$i18n)
        this.avtiveIndex = index
        this.blogCategory = type
        this.pageNum = 1
        this.blogListData = []
        this.getBlogList()
      },
      async getBlogList() {
        const languageCode = langMap[this.$i18n.loadedLanguages[0]] || 'en-US'
        // const languageCode = langMap[i18n.loadedLanguages[0]] || 'en-US'
        const { data, totalCount } = await this.$api.blogApi.getBlogList({
          languageCode,
          blogCategory: this.blogCategory,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.hsaMore = this.pageNum * this.pageSize < totalCount

        data.length &&
          data.forEach((item) => {
            this.blogListData.push(item)
          })
        // this.blogListData = data
      },
      loadMore() {
        ++this.pageNum
        this.getBlogList()
      }
    }
  }
</script>

<style scoped lang="scss">
  .main {
    padding-top: 3.9583vw;
  }
  .blog-banner {
    height: 3.6rem;
    background: url('@/assets/images/blog/blog-banner.jpg') no-repeat center;
    background-size: cover;
  }
  .banner-text-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    text-align: center;
    line-height: 1.5;
    transform: translate(-50%, -50%);
  }
  .main-title {
    font-size: 0.48rem;
    line-height: 1.5;
  }
  .content {
    padding-top: 0.4rem;
  }
  :deep(.ivu-tabs-bar) {
    border-bottom: none !important;
    font-size: 16px;
  }
  :deep(.ivu-tabs-tab) {
    font-weight: 700;
    font-size: 16px;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
  }
  :deep(.ivu-tabs-nav .ivu-tabs-tab:hover) {
    color: #000;
  }
  :deep(.ivu-tabs-nav .ivu-tabs-tab-active) {
    color: #000;
    font-weight: 600;
  }
  :deep(.ivu-tabs-ink-bar) {
    background-color: #333;
  }
  // :deep(.ivu-tabs-nav-scroll) {
  //   margin-left: calc(50% - 290px);
  //   width: 100%;
  //   top: 3.9583vw;
  //   left: 0;
  //   padding: 0.2rem 0;
  //   position: sticky;
  //   z-index: 9;
  //   background-color: #fff;
  //   border-bottom: 1px solid transparent;
  // }
  // .tab-nav {
  //   width: 100%;
  //   top: 3.9583vw;
  //   left: 0;
  //   padding: 0.2rem 0;
  //   position: sticky;
  //   z-index: 9;
  //   background-color: #fff;
  //   border-bottom: 1px solid transparent;
  // }
  // :deep(.ivu-tabs) {
  //   overflow: inherit;
  // }
  // :deep(.ivu-tabs-nav-wrap) {
  //   overflow: inherit;
  // }
  :deep(.ivu-tabs-bar) {
    width: 100%;
    top: 3.9583vw;
    left: 0;
    padding: 0.2rem 0;
    position: sticky;
    z-index: 9;
    background-color: #fff;
    border-bottom: 1px solid transparent;
    display: flex;
    justify-content: center;
  }

  .tabs {
    width: 100%;
    top: 3.9583vw;
    left: 0;
    // padding: 0.2rem 0;
    position: sticky;
    z-index: 9;
    background-color: #fff;
    // border-bottom: 1px solid transparent;
    // box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 10%);
  }
  .tabs h2 {
    font-weight: 400;
    margin: 0 0.5rem;
    font-size: 16px;
    position: relative;
  }
  .tabs h2 span {
    display: block;
    padding: 0.2rem 0;
    cursor: pointer;
  }
  .tabs h2 span:hover {
    color: #333;
  }
  .tabs .curr {
    color: #333;
  }
  .tabs h2::after {
    transition: width 0.2s;
    will-change: width;
    content: '';
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 2px;
    background-color: #303030;
  }
  .tabs h2.curr::after,
  .tabs h2:hover::after {
    width: 100%;
  }
  .tabs h2.curr {
    font-weight: 700;
  }
  .more-btn a {
    display: inline-block;
    margin-bottom: 0.8rem;
    padding: 0 0.32rem;
    line-height: 0.4rem;
    font-size: 0.16rem;
    border: 1px solid #333;
    box-sizing: border-box;
    &:hover {
      background-color: rgba(128, 128, 128, 0.1);
    }
  }
</style>
